// extracted by mini-css-extract-plugin
export default {"errorMessage":"MyTextArea_errorMessage__1vd0j"};